const PUBLIC_ASSET_PREFIX = process.env.PUBLIC_URL ? `${process.env.PUBLIC_URL}/assets` : "/assets";

export const DEFAULT_ARTWORK_PRELOADER = `${PUBLIC_ASSET_PREFIX}/artwork-preloader.glb`;
export const DEFAULT_SOUND_MODEL_URL = `${PUBLIC_ASSET_PREFIX}/sound-holder.glb`;
/** Default image for blank artwork */
export const DEFAULT_ARTWORK_MODEL_URL = `${PUBLIC_ASSET_PREFIX}/art-holder.glb`;
export const FRAME1_ARTWORK_MODEL_URL = `${PUBLIC_ASSET_PREFIX}/art-holder-frame1.glb`;
export const FRAME1_PPRT_ARTWORK_MODEL_URL = `${PUBLIC_ASSET_PREFIX}/art-holder-frame1-pprt.glb`;

export const DEFAULT_ARTWORK_MODEL_IMAGE_URL = `${PUBLIC_ASSET_PREFIX}/blank-artwork.png`;
/** Navigation arrow image path */
export const ARROW_IMAGE_URL = "/assets/next.png";
/** Canvas width for artwork title */
export const ARTWORK_CANVAS_TITLE_WIDTH = 2048;
/** Canvas height for artwork title */
export const ARTWORK_CANVAS_TITLE_HEIGHT = 512;
/** Font settings for artwork title */
export const ARTWORK_CANVAS_TITLE_FONT = '240px Arial';
/** Fill color for artwork title */
export const ARTWORK_CANVAS_TITLE_FILL_STYLE = 'white';
/** Stroke color for artwork title */
export const ARTWORK_CANVAS_TITLE_STROKE_STYLE = 'black';
/** Vertical position for artwork title */
export const ARTWORK_CANVAS_TITLE_Y_POSITION = 0.85;

export const DEBUG_SLOTS = true;

